import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export function RecordDetails({ items, summary = false }: { items: { label: string; value: ReactNode }[]; summary?: boolean }) {
  return <dl className={cx('record-details', summary && 'record-details--summary')}>
    {items.map((item, index) => <div key={index}><dt>{item.label}</dt><dd>{item.value}</dd></div>)}
  </dl>;
}
